// Tip service metadata + link builders. Values are stored raw; we normalize to a URL.
export const TIP_SERVICES = [
    { key: "paypal", label: "PayPal.me", placeholder: "yourname (or full paypal.me link)", home: "https://www.paypal.com/paypalme/grab" },
    { key: "venmo", label: "Venmo", placeholder: "@your-handle", home: "https://venmo.com/signup" },
    { key: "cashapp", label: "Cash App", placeholder: "$yourtag", home: "https://cash.app" },
    { key: "kofi", label: "Ko-fi", placeholder: "yourname", home: "https://ko-fi.com" },
    { key: "bmac", label: "Buy Me a Coffee", placeholder: "yourname", home: "https://www.buymeacoffee.com" },
];

function ensureHttp(v) {
    if (/^https?:\/\//i.test(v)) return v;
    return `https://${v}`;
}

export function tipUrl(key, raw) {
    const v = (raw || "").trim();
    if (!v) return null;
    if (/^https?:\/\//i.test(v)) return v;  // user pasted a full link
    switch (key) {
        case "paypal": return `https://paypal.me/${v.replace(/^@/, "")}`;
        case "venmo": return `https://venmo.com/${v.replace(/^@/, "")}`;
        case "cashapp": return `https://cash.app/$${v.replace(/^\$/, "")}`;
        case "kofi": return `https://ko-fi.com/${v}`;
        case "bmac": return `https://buymeacoffee.com/${v}`;
        case "other_url": return ensureHttp(v);
        default: return ensureHttp(v);
    }
}

/** Returns array of {label, url} for a tip_links map (only filled entries). */
export function tipEntries(tipLinks) {
    if (!tipLinks) return [];
    const out = [];
    for (const s of TIP_SERVICES) {
        const url = tipUrl(s.key, tipLinks[s.key]);
        if (url) out.push({ label: s.label, url });
    }
    const otherUrl = tipUrl("other_url", tipLinks.other_url);
    if (otherUrl) out.push({ label: (tipLinks.other_label || "Tip").trim() || "Tip", url: otherUrl });
    return out;
}
